import React, { useState } from 'react';

interface Props {
  onLogin: () => void;
}

const LoginPage: React.FC<Props> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      if (!res.ok) {
        throw new Error('Неверный логин или пароль');
      }
      const data = await res.json();
      localStorage.setItem('token', data.token);
      localStorage.setItem('userEmail', email);
      localStorage.removeItem('storeName');
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('storeNameChanged'));
      }
      if (data.role) {
        localStorage.setItem('userRole', data.role);
      }
      if (data.roleLevel !== undefined) {
        localStorage.setItem('userRoleLevel', String(data.roleLevel));
      }
      onLogin();
    } catch (err: any) {
      setError(err.message || 'Ошибка авторизации');
    }
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <form className="bg-white p-6 w-72 shadow flex flex-col" onSubmit={handleSubmit}>
        <h2 className="text-lg font-bold mb-2">Вход</h2>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        <input
          type="email"
          placeholder="Email"
          className="border p-2 mb-3 text-sm"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="border p-2 mb-3 text-sm"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <button type="submit" className="px-3 py-1 bg-blue-500 text-white rounded">Войти</button>
      </form>
    </div>
  );
};

export default LoginPage;
